// src/components/LeavingSiteModal.js

import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useLeavingSiteModal } from "../context/LeavingSiteModalContext";

const LeavingSiteModal = () => {
	const { isVisible, externalLink, hideLeavingSiteModal } =
		useLeavingSiteModal();

	const handleClose = () => {
		hideLeavingSiteModal();
	};

	return (
		<Modal show={isVisible} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>You’re Leaving Our Site</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>
					You’re about to leave our website. If you trust this link, click below
					to continue:
				</p>
				{externalLink && (
					<p>
						<a
							onClick={handleClose}
							href={externalLink}
							target="_blank"
							rel="noopener noreferrer"
							style={{ wordWrap: "break-word" }}
						>
							{externalLink}
						</a>
					</p>
				)}
			</Modal.Body>
			{/* <Modal.Footer>
				<Button
					style={{
						borderRadius: "200px",
					}}
					className=" px-4 mt-3 py-2"
					variant="secondary"
					onClick={handleClose}
				>
					Close
				</Button>
			</Modal.Footer> */}
		</Modal>
	);
};

export default LeavingSiteModal;
